/**
 * VideoPodcastForm - Form for adding YouTube-based video podcasts
 */
import { Youtube, Loader2 } from 'lucide-react';
import { Button } from '../../ui/button';

export const VideoPodcastForm = ({ 
  formData, 
  setFormData, 
  onSubmit, 
  onCancel, 
  adding 
}) => {
  return (
    <form onSubmit={onSubmit} className="bg-zinc-900 rounded-xl p-6 space-y-4 border border-white/10">
      <h3 className="text-white font-bold flex items-center gap-2">
        <Youtube className="w-5 h-5 text-red-500" />
        Add Video Podcast from YouTube
      </h3>
      
      <div className="bg-green-500/10 border border-green-500/30 p-3 rounded text-sm text-green-400">
        <p><strong>✓ Auto-Import:</strong> When you add a playlist or channel URL, all videos will be automatically imported with thumbnails, titles, and dates!</p>
      </div>

      <div>
        <label className="block text-zinc-400 text-sm mb-1">YouTube URL *</label>
        <input
          type="url"
          value={formData.youtube_url}
          onChange={(e) => setFormData({ ...formData, youtube_url: e.target.value })}
          placeholder="https://youtube.com/@channel or https://youtube.com/playlist?list=..."
          className="w-full bg-zinc-800 border border-white/10 text-white px-4 py-2 rounded"
          required
          data-testid="video-youtube-url"
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-zinc-400 text-sm mb-1">Podcast Name *</label>
          <input
            type="text"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            placeholder="e.g., Game Day Breakdowns"
            className="w-full bg-zinc-800 border border-white/10 text-white px-4 py-2 rounded"
            required
          />
        </div>
        <div>
          <label className="block text-zinc-400 text-sm mb-1">Category</label>
          <select
            value={formData.category}
            onChange={(e) => setFormData({ ...formData, category: e.target.value })}
            className="w-full bg-zinc-800 border border-white/10 text-white px-4 py-2 rounded"
          >
            <option value="Sports">Sports</option>
            <option value="Highlights">Highlights</option>
            <option value="Analysis">Analysis</option>
            <option value="Interview">Interview</option>
            <option value="Entertainment">Entertainment</option>
          </select>
        </div>
      </div>

      <div>
        <label className="block text-zinc-400 text-sm mb-1">Description</label>
        <textarea
          value={formData.description}
          onChange={(e) => setFormData({ ...formData, description: e.target.value })}
          placeholder="Describe your video podcast..."
          rows={2}
          className="w-full bg-zinc-800 border border-white/10 text-white px-4 py-2 rounded"
        />
      </div>

      <div className="flex gap-2 pt-2">
        <Button type="submit" disabled={adding} className="bg-red-600 hover:bg-red-700">
          {adding ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Youtube className="w-4 h-4 mr-2" />}
          Create Video Podcast
        </Button>
        <Button type="button" variant="outline" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </form>
  );
};

export default VideoPodcastForm;
